<template>
    <div class="details_body">
        <ul class="details_tab">
            <li @click="num = 0" :class="{active: num == 0}">wh8介绍</li>
            <li @click="num = 1" :class="{active: num == 1}">功能介绍</li>
            <li @click="num = 2" :class="{active: num == 2}">购买须知</li>
            <!-- <li @click="num = 3" :class="{active: num == 3}">服务介绍</li> -->
        </ul>
        <div class="details_gn" v-show="num == 0">
            <p>赢智量化交易软件wh8，是文华财经旗下的一款量化交易软件。资产管理层面的专业视角，回测和运行分离的开创性设计，积木式编程语言、主连链回测、多模型组合回测、运行模组、远程运行监控、产品申购/赎回管理...</p>
            <div class="tips">安全提示：交易过程中请勿点击不明来源的链接，付款前请务必详细核对支付信息</div>
        </div>
        <div class="details_gn" v-show="num == 1">
            <p class='detail_title'>8C基础功能包（页面盒子+模组）</p>
            <p>1.400多个基本编写函数，包括基本面量化函数、循环执行函数、绘图函数、头寸函数、模型加密函数等；</p>
            <p>2.逐笔tick数据回测还原交易过程，提供专业的测试报告，资金曲线，参数优化，及多模型组合回测；</p>
            <p>3.页面盒子后台运行，支持256个模型的信号监测、多窗口平铺观测信号、查看历史信号记录、半自动下单。</p>
            <p>4.模组后台全自动运行，支持运行单元资金/持仓管理、产品申购赎回管理、自动移仓换月、策略优化运行、运行分析报告、分区总资金曲线、远程服务器监控及日志邮件发送通知。</p>
            <!-- <p class='tent'>* 仅限使用wh8软件登录；</p> -->
            <p class='tent'>* 本服务中必须提供的数据及信息仅限用户另外付费选配的范围；服务期内我司有权对其他数据及信息进行增、减等调整。</p>
            <!-- <p><a href='https://cxh.wenhua.com.cn/buy.asp' target='_blank'>>>> 查看8C基础功能包 (盒子+模组)更多功能</a></p> -->
            <div class="tips">安全提示：交易过程中请勿点击不明来源的链接，付款前请务必详细核对支付信息</div>
        </div>
        <div class="details_gn" v-show="num == 2">
            <!-- <p class='tent'>1.购买前请先下载<a href='https://cxh.wenhua.com.cn/download.asp' target='_blank'>wh8</a>体验版了解软件基础功能。</p> -->
            <p class='tent'>
                2.使用wh8软件的电脑配置要求：<br />
                · CPU：X86架构，4核及以上配置；<br />
                · 内存：要达到8G及以上；<br />
                · 操作系统：win7/win8/win10/win2008的64位；
            </p>
            <p class='tent'>3.推荐南方地区使用电信网络，北方地区使用联通网络，其它网络使用效果不佳。</p>
            <!-- <p class='tent'>4.使用授权账号登录后可选择文华支持的任意期货公司进行交易（<a href='https://cxh.wenhua.com.cn/jytd.asp?pid=1' target='_blank'>查看文华支持的期货公司名单</a>），但如以后因所开户的期货公司交易通道关闭，文华不负责解决并不退还剩余费用。</p> -->
            <div class="tips">安全提示：交易过程中请勿点击不明来源的链接，付款前请务必详细核对支付信息</div>
        </div>
        <div class="details_gn" v-show="num == 3"></div>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                num: 0
            }
        },
    }
</script>
<style scope>
@import url('./doc.css');
    .details_gn{
        min-height: 350px;
    }
</style>